/**
 * @generated SignedSource<<caf203e6d50a85931ae87b988e667ad9>>
 * @relayHash 9766437351d45e8f988f1b9517f8d95d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fc6f224a2d810f0aa1a2e6a2edece177fe4fa2839dd95a4fd3010d3ce09f146c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RichTextPopUpContentQuery } from './RichTextPopUpContentQuery.graphql';

const node: PreloadableConcreteRequest<RichTextPopUpContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fc6f224a2d810f0aa1a2e6a2edece177fe4fa2839dd95a4fd3010d3ce09f146c",
    "metadata": {},
    "name": "RichTextPopUpContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
